import { ChevronRight20Regular } from '@/components/Icon'
import styles from './HomeNavPane.module.scss'

/**
 * One Pulse destination. A chevron marks the row as the open one rather than
 * as "has children" — nothing here expands in place.
 */
export default function HomeNavPulseRow({
  Icon,
  label,
  active = false,
  onClick,
  disabled = false,
}) {
  return (
    <button
      type="button"
      className={`${styles.row}${active ? ` ${styles.rowActive}` : ''}`}
      aria-current={active ? 'page' : undefined}
      aria-disabled={disabled || undefined}
      onClick={disabled ? undefined : onClick}
    >
      {Icon ? <Icon className={styles.rowIcon} aria-hidden /> : null}
      <span className={styles.rowLabel}>{label}</span>
      {active ? <ChevronRight20Regular className={styles.rowChevron} aria-hidden /> : null}
    </button>
  )
}
